export class workspaceStatusConstant {
  static readonly OPEN: string = "OPEN";
  static readonly CLOSED: string = "CLOSED";
  static readonly LOCK: string = "Lock";
  static readonly UNLOCK: string = "Unlock";
}
